import NewAdvertPage from './NewAdvertPage';
export default NewAdvertPage; 